import { FETCH_CARCATS, FETCH_CARCAT, FETCH_CARS, FETCH_CAR } from './types';

export const fetchCarCats = () => dispatch => {
    fetch('https://sinomost.kz/API/catcar/cats/')
    .then(res => res.json())
    .then(carcats => dispatch({
        type: FETCH_CARCATS,
        payload: carcats
    }));
};
export const fetchCarCat = (id) => dispatch => {
    fetch(`https://sinomost.kz/API/catcar/cat/${id}/`)
    .then(res => res.json())
    .then(carcat => dispatch({
        type: FETCH_CARCAT,
        payload: carcat
    }));
};

export const fetchCars = (id) => dispatch => {
    fetch(`https://sinomost.kz/API/catcar/cars/${id}/`)
    .then(res => res.json())
    .then(cars => dispatch({
        type: FETCH_CARS,
        payload: cars
    }));
};

export const fetchAllCars = () => dispatch => {
    fetch(`https://sinomost.kz/API/catcar/cars/`)
    .then(res => res.json())
    .then(cars => dispatch({
        type: FETCH_CARS,
        payload: cars
    }));
};

export const fetchCar = (id) => dispatch => {
    fetch(`https://sinomost.kz/API/catcar/car/${id}/`)
    .then(res => res.json())
    .then(car => dispatch({
        type: FETCH_CAR,
        payload: car
    }));
};
